import React from 'react'

const WineryRegionFilter = ({regions, selectedRegions, handleChange, selectedState}) => {
  const tempRegions = selectedState !== "" ? regions.filter(region => region.state === selectedState) : regions;

  const handleOnChange = (e) => {
    if(e.target.checked){
      handleChange([...selectedRegions, e.target.name], 'regions')
    } else {
      handleChange([...selectedRegions].filter(x => x !== e.target.name), 'regions')
    }
  }

  return (
    <div>
      <h3>Winery Region</h3>
      {tempRegions && tempRegions.map((region, index) => (
        <div key={index} style={{display: 'flex', alignItems: 'center'}}>
          <input
            type="checkbox"
            id={region.name}
            name={region.name}
            onChange={handleOnChange}
            checked={selectedRegions?.includes(region.name)}
            style={{display: 'inline-block', width: 'auto', marginRight: "10px"}}
          />
          <label htmlFor={region.name}>{region.name}</label>
        </div>
      ))}
    </div>
  )
}

export default WineryRegionFilter
